
<template>
  <div class="record_box">
    <div class="br_box">
      <img class="banner"
           :src="imgBig" />
    </div>
    <div class="bag_title">
      <p class="name">{{customizeName}} <span class="readPeople right">{{receiveCount}}人已领取</span></p>
      <div class="item">
        <ul>
          <li v-for="(item,index) in cardList"
              :key="index"
              @click="changeStatus(index,item)"
              :class="{'act_bd':status == index}">
            <p class="cardType">{{item.rank}}</p>
            <p class="money"><span class="icon"></span>{{item.goldPrice}}</p>
            <p class="originMoney">￥{{item.price}}</p>
            <span class="trian"
                  v-show="status == index"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="serves">
      <p class="title">服务项目</p>
      <img class="bg"
           :src="servicePic"
           alt="">
    </div>
    <div class="btn_box">
      <span class="btn"
            :class="{'btnAct':noCoins}"
            @click="toShow">{{currentBtnText}}</span>
    </div>
    <MessageInfo :propJson="propJson"
                 @sureClick="sureClick"
                 @secondClick="secondClick" />
  </div>
</template>
<script>
import MessageInfo from '@/components/messageInfo';
export default {
  components: {
    MessageInfo
  },
  data () {
    return {
      propJson: {
        title: '提示',
        messLeft: '您即将花费',
        messCenter: '金币',
        messRight: '',
        cacleBtn: '稍后兑换',
        sureBtn: '立即兑换',
        showToast: false,
        isSecond: false,
      },
      receiveCount: '',
      currentPrice: '',
      currentPriceName: '',
      customizeName: '',
      servicePic: '',
      imgBig: '',
      currentBtnText: '立即兑换',
      noCoins: false,
      status: '0',
      copyText: '',
      btnText: '复制券码',
      isCopy: false,
      money: '',
      id: '',
      gold: '',
      couponId: '',
      balanceList: [],
      cardList: [],
      appVersion: localStorage.getItem('appVersion'),
    }
  },
  mounted () {
    this.util.title('券详情-可兑换');
    this.appVersion = localStorage.getItem('appVersion');
    this.id = this.$route.query.id
    this.getDetail(1)
  },
  methods: {
    sureClick () {
      this.toExchangeCoupon();
    },
    secondClick () {
      this.toPage();
    },
    toPage (path, item) {
      // if (parseFloat(this.appVersion) >= parseFloat('1.3.0')) {
      //   //去原生卡券页面
      //   this.util.toClientPath(5);
      // } else {
      //走H5卡券页面
      this.$router.push({
        path: '/vipActive/myCard',
      });
      // }
    },

    toShow () {
      if (!this.noCoins) {
        if (this.propJson.isSecond) {
          this.propJson = {
            title: '提示',
            messLeft: '您即将花费',
            messCenter: this.currentPrice + '金币',
            messRight: `，兑换 ${this.currentPriceName}`,
            cacleBtn: '稍后兑换',
            sureBtn: '立即兑换',
            isSecond: false,
            showToast: true,
          }
        } else {
          this.propJson.showToast = true;
        }
      }
    },
    // 复制成功
    onCopy (e) {
      this.isCopy = true;
      this.btnText = '券码已复制！'
    },
    // 复制失败
    onError (e) {
      this.util.toast({ msg: '复制失败' })
    },
    changeStatus (isDefault, item) {
      this.currentPriceName = item.customizeName;
      this.currentPrice = item.goldPrice;
      this.status = isDefault
      this.propJson.messCenter = this.currentPrice + '金币';
      this.propJson.messRight = `，兑换 ${item.customizeName}`;
      this.customizeName = this.currentPriceName;
      this.couponId = item.id;
      this.receiveCount = item.receiveCount;
      if (Number(this.gold) < Number(item.goldPrice)) {
        this.noCoins = true;
        this.currentBtnText = '金币不足，无法兑换'
      } else {
        this.noCoins = false;
        this.currentBtnText = '立即兑换'
      }
    },
    getDetail (isFirst) {
      let _this = this;
      this.$get('/app/valueAdded/goldProducts/' + this.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.gold = e.data.gold;
            _this.cardList = e.data.data;
            _this.currentPriceName = _this.cardList[0].customizeName;
            if (isFirst) {
              this.currentPrice = _this.cardList[0].goldPrice;
            }
            _this.customizeName = _this.currentPriceName;
            _this.imgBig = _this.cardList[0].imgBig;
            _this.servicePic = _this.cardList[0].servicePic;
            _this.propJson.messCenter = _this.currentPrice + '金币';
            _this.propJson.messRight = `，兑换 ${_this.currentPriceName}`;
            _this.couponId = _this.cardList[0].id;
            _this.receiveCount = _this.cardList[0].receiveCount;
            if (Number(_this.gold) < Number(_this.currentPrice)) {
              _this.noCoins = true;
              _this.currentBtnText = '金币不足，无法兑换'
            } else {
              _this.noCoins = false;
              _this.currentBtnText = '立即兑换'
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    toExchangeCoupon () {
      let _this = this;
      this.$post('/app/valueAdded/exchangeCoupon/' + this.couponId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.getDetail();
            //调用接口立即兑换
            this.propJson = {
              title: '提示',
              message: '恭喜兑换成功！已放入我的卡券',
              cacleBtn: '稍后查看',
              sureBtn: '前往查看',
              showToast: true,
              isSecond: true,
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    }
  }

}
</script>
<style scoped>
.record_box {
  background: #f7f7f7;
  width: 100%;
  /* height: 100%; */
  padding-bottom: 0.1rem;
}
.br_box {
  padding: 0.15rem;
  padding-bottom: 0;
  height: 1.26rem;
}
.banner {
  display: inline-block;
  /* background: url("../../assets/img/vip/card/bag_bg.png") no-repeat center
    center;
  background-size: 100% 100%; */
  height: 1.11rem;
  width: 100%;
}
.bag_title {
  background: #fff;
  padding: 0.18rem 0.15rem;
  padding-bottom: 0.1rem;
  margin-bottom: 0.1rem;
}
.bag_title .name {
  font-size: 0.17rem;
  color: #333;
  font-family: PingFangSC;
  font-weight: 700;
  position: relative;
}
.money {
  color: #ff514a;
  font-size: 0.22rem;
  font-family: PingFangSC;
  font-weight: 500;
  position: relative;
  margin-top: 0.1rem;
}
.originMoney {
  color: #cccccc;
  font-size: 0.14rem;
  text-decoration: line-through;
}
.bag_title .readPeople {
  font-size: 0.12rem;
  color: #999;
  position: absolute;
  bottom: 0.05rem;
  right: 0;
}
.serves {
  padding: 0.15rem;
  background: #ffffff;
  font-size: 0.12rem;
  color: #333;
}
.serves {
  margin-bottom: 0.1rem;
  clear: both;
  overflow: hidden;
}
.title {
  color: #333;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
  font-family: PingFangSC;
  font-weight: 500;
}
.btn_box {
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0.3rem;
}
.btn {
  display: inline-block;
  width: 85%;
  margin: 0 auto;
  color: #fff;
  height: 0.5rem;
  text-align: center;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 25px;
  line-height: 0.5rem;
  font-size: 0.17rem;
}
.btnAct {
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  opacity: 0.4;
}
.serves .bg {
  /* width: 2.95rem; */
  height: 0.52rem;
}
.item {
  width: 100%;
  background: #fff;
  padding: 0.15rem 0;
  overflow-x: scroll;
  padding-bottom: 0.05rem;
}
.item ul {
  /* width: 4.18rem; */
  width: 5.25rem;
}
.item li {
  width: 1rem;
  height: 1.18rem;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  margin-right: 0.06rem;
  display: inline-block;
  text-align: center;
  position: relative;
}
.item li:last-child {
  margin-right: 0;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 11;
  top: 0;
  left: 0;
}
.toast {
  width: 80%;
  margin: 0 auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 111;
  background: #fff;
  text-align: center;
  border-radius: 10px;
  padding-top: 0.44rem;
  padding-bottom: 0.3rem;
}
.toast .logo {
  width: 0.99rem;
  height: 0.85rem;
}
.toast .ts_title {
  color: #000;
  font-size: 0.16rem;
  margin-bottom: 0.18rem;
}
.toast .ts_code {
  color: #333;
  font-size: 0.26rem;
  font-family: PingFangSC;
  font-weight: 500;
  margin-bottom: 0.17rem;
}
.btn_copy,
.btn_alCopy {
  background: #ffffff;
  border: 1px solid rgba(79, 140, 250, 1);
  color: #4f8cfa;
  margin-bottom: 0.1rem;
}
.btn_alCopy {
  border: 1px solid rgba(238, 238, 238, 1);
  color: #c2c2c2;
}
.toast .close {
  background: url('../../assets/img/vip/card/toast_close.png') no-repeat center
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
}
.icon {
  background: url('../../assets/img/vip/card/coins_icon.png') no-repeat center
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
  position: relative;
  top: 0.03rem;
  left: -0.05rem;
}
.trian {
  background: url('../../assets/img/vip/card/triangle.png') no-repeat center
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  right: 0;
  bottom: 0;
}
.cardType {
  font-size: 0.14rem;
  color: #333;
  margin-top: 0.1rem;
}
.item li.act_bd {
  background: rgba(255, 228, 228, 0.24);
  border-radius: 2px;
  border: 1px solid rgba(255, 135, 86, 1);
}
</style>
